import { MastersProvider, useMasters } from "../components/masters/MastersContext";
import { DirectoryWizard } from "../components/masters/DirectoryWizard";
import { CustomersSection } from "../components/masters/CustomersSection";
import { DeptContactsSection } from "../components/masters/DeptContactsSection";
import { AutoFiledSection } from "../components/masters/AutoFiledSection";
import { BankAccountsSection } from "../components/masters/BankAccountsSection";
import { VehiclesSection } from "../components/masters/VehiclesSection";
import { DriversSection } from "../components/masters/DriversSection";
import { BrokersSection } from "../components/masters/BrokersSection";
import { SubTransportersSection } from "../components/masters/SubTransportersSection";
import { LocationsSection } from "../components/masters/LocationsSection";
import { PeopleSection } from "../components/masters/PeopleSection";
import { DuplicatesSection } from "../components/masters/DuplicatesSection";

function MastersInner() {
  const { err, loadAll } = useMasters();
  return (
    <div data-testid="masters-page">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-[#68665E] font-semibold">Operations</div>
        <h1 className="font-headings text-4xl font-bold text-[#1A1A18] mt-1">Vehicles & Drivers</h1>
        <p className="text-sm text-[#68665E] mt-2">Saved here once, picked from a dropdown when creating LRs.</p>
      </div>

      {err && <div className="badge-error mb-4 py-2 px-3">{err}</div>}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <DirectoryWizard onChange={loadAll} />
        <CustomersSection />
        <DeptContactsSection />
        <AutoFiledSection />
        <BankAccountsSection />
        <VehiclesSection />
        <DriversSection />
        <BrokersSection />
        <SubTransportersSection />
        <LocationsSection />
        <PeopleSection />
        <DuplicatesSection />
      </div>
    </div>
  );
}

export default function Masters() {
  return (
    <MastersProvider>
      <MastersInner />
    </MastersProvider>
  );
}
